var _rect, _rect2, _g, _rect3, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegarmImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    stroke: "#DBDEE1",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_4462_27449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5918,
    y: 24,
    width: 28.0945,
    height: 17.5591,
    rx: 8.77954,
    fill: "url(#paint0_linear_4462_27449)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.74023,
    y: 8.74219,
    width: 30.4357,
    height: 30.4357,
    rx: 12.3724,
    fill: "#2AAAE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3723 23.9509L19.2564 25.27L28.4776 19.6327C28.6112 19.5509 28.7482 19.7324 28.6329 19.8386L21.6518 26.2643L21.3922 29.8618C21.3724 30.1355 21.7021 30.2878 21.8977 30.0955L24.0472 27.9818L27.9766 30.9564C28.4002 31.2771 29.0135 31.0511 29.1277 30.5323L31.8638 18.109C32.0199 17.4003 31.3254 16.8023 30.6477 17.0618L15.3526 22.9187C14.8728 23.1024 14.8859 23.7857 15.3723 23.9509Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4462_27449",
    x: 7.34002,
    y: 21.7482,
    width: 32.5973,
    height: 22.0621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12589,
    result: "effect1_foregroundBlur_4462_27449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4462_27449",
    x1: 23.6391,
    y1: 41.046,
    x2: 23.6391,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegarmImg);
export default __webpack_public_path__ + "static/media/telegarm-img.0b4c6b8fcaf32216225c22e3e0a0e498.svg";
export { ForwardRef as ReactComponent };